import React, { useEffect } from "react";
import images from "../../../themes/appImage";
import { DatePicker, Select } from "antd";
import * as Yup from "yup";
import moment from "moment";
import { useFormik } from "formik";
import {
  avatarListLoad,
  createUserLoad,
  createUserSuccess,
  genderListLoad,
} from "../../../redux/slices/createUser.slice";
import { useDispatch, useSelector } from "react-redux";
import { imageURL } from "../../../redux/Api/apikit";
import { useNavigate } from "react-router-dom";
import { naviagetFn } from "../../../common/navigator";

function CreateUser({ setTab }) {
  const navigate = useNavigate();
  naviagetFn(navigate);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(avatarListLoad());
    dispatch(genderListLoad());
  }, [dispatch]);

  const IsSuccess = useSelector((state) => state?.createUserReducer?.isSucess);

  useEffect(() => {
    if (IsSuccess) {
      setTab("1");
      dispatch(createUserSuccess(false));
    }
  }, [IsSuccess]);

  const avatars = useSelector((state) => {
    const data = state.createUserReducer.avatars?.data;
    if (!data) return [];
    return Array.isArray(data) ? data : data.list || [];
  });

  // Normalize genderResponse
  const genderResponse = useSelector((state) => {
    const data = state.createUserReducer.gender?.data;
    if (!data) return [];
    return Array.isArray(data) ? data : data.list || [];
  });

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .min(3, "First name must be at least 3 characters")
      .max(15, "First name cannot exceed 15 characters")
      .matches(/^[A-Za-z]+$/, "Please enter valid first name")
      .required("Please enter first name"),

    lastName: Yup.string()
      .min(3, "Last name must be at least 3 characters")
      .max(15, "Last name cannot exceed 15 characters")
      .matches(/^[A-Za-z]+$/, "Please enter valid last name.")
      .required("Please enter last name"),

    userName: Yup.string()
      .min(3, "Username must be at least 3 characters")
      .max(15, "Username cannot exceed 15 characters")
      // .matches(
      //   /^[A-Za-z]+$/,
      //   "Username must contain only letters (no numbers or special characters)"
      // )
      .required("Please enter user name"),

    gender: Yup.string().required("Please select gender"),
    dob: Yup.string().required("Please select date of birth"),
    avatar: Yup.string().required("Please select avatar"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      userName: "",
      gender: "",
      dob: "",
      avatar: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      const selected = avatars.find((a) => a?._id === values.avatar);
      console.log("valuessssss: ", values);
      formData.append("firstName", values.firstName);
      formData.append("lastName", values.lastName);
      formData.append("userName", values.userName);
      formData.append("identityType", values.gender);
      formData.append("dob", values.dob);
      formData.append("avatar", selected.avatar);

      dispatch(createUserLoad(formData));
    },
  });

  const { Option } = Select;

  return (
    <div>
      <h3 className="text-[23px] ml-14 mt-6">Create User</h3>
      <form
        className="mt-4 ml-14 space-y-4 w-[700px]"
        onSubmit={formik.handleSubmit}
      >
        <div>
          <label className="block mb-1">First Name</label>
          <input
            type="text"
            name="firstName"
            value={formik.values.firstName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Enter first name"
            className="border p-2 rounded w-full h-[51px]"
          />
          {formik.touched.firstName && formik.errors.firstName && (
            <div className="text-red-500 text-xs mt-1">
              {formik.errors.firstName}
            </div>
          )}
        </div>
        <div>
          <label className="block mb-1">Last Name</label>
          <input
            type="text"
            name="lastName"
            value={formik.values.lastName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Enter last name"
            className="border p-2 rounded w-full h-[51px]"
          />
          {formik.touched.lastName && formik.errors.lastName && (
            <div className="text-red-500 text-xs mt-1">
              {formik.errors.lastName}
            </div>
          )}
        </div>
        <div>
          <label className="block mb-1">Username</label>
          <input
            type="text"
            name="userName"
            value={formik.values.userName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Enter username"
            className="border p-2 rounded w-full h-[51px]"
          />
          {formik.touched.userName && formik.errors.userName && (
            <div className="text-red-500 text-xs mt-1">
              {formik.errors.userName}
            </div>
          )}
        </div>
        <div>
          <label className="block mb-1">Date of Birth</label>
          <DatePicker
            className="w-full border rounded p-2"
            name="dob"
            value={formik.values.dob ? moment(formik.values.dob) : null}
            onChange={(date, dateString) =>
              formik.setFieldValue("dob", dateString)
            }
            onBlur={() => formik.setFieldTouched("dob", true)}
            placeholder="Select date of birth"
            format="YYYY-MM-DD"
          />
          {formik.touched.dob && formik.errors.dob && (
            <div className="text-red-500 text-xs mt-1">{formik.errors.dob}</div>
          )}
        </div>
        <div>
          <label className="block mb-1">Avatar</label>
          <Select
            name="avatar"
            className="w-full"
            placeholder="Select Avatar"
            value={formik.values.avatar || undefined}
            onChange={(value) => {
              formik.setFieldValue("avatar", value)
            }}
            onBlur={() => formik.setFieldTouched("avatar", true)}
            dropdownClassName="Avatar-drop"
          >
            {avatars.map((item) => (
              <Option key={item._id} value={item._id}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <img
                    src={imageURL + item.avatar}
                    className="w-8 h-8 rounded-full"
                    crossOrigin="*"
                  />
                </div>
              </Option>
            ))}
          </Select>
          {formik.touched.avatar && formik.errors.avatar && (
            <div className="text-red-500 text-xs mt-1">
              {formik.errors.avatar}
            </div>
          )}
        </div>
        <div>
          <label className="block mb-1">Gender</label>
          <Select
            name="gender"
            className="w-full"
            placeholder="Select Gender"
            value={formik.values.gender || undefined}
            onChange={(value) => formik.setFieldValue("gender", value)}
            onBlur={() => formik.setFieldTouched("gender", true)}
          >
            {genderResponse.map((item) => (
              <Option key={item._id} value={item.name}>
                {item.name}
              </Option>
            ))}
          </Select>
          {formik.touched.gender && formik.errors.gender && (
            <div className="text-red-500 text-xs mt-1">
              {formik.errors.gender}
            </div>
          )}
        </div>
        <div className="btn-schedule mt-9 mb-3">
          <button className="ml-0" type="submit">
            Create User
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateUser;
